import { gql } from '@apollo/client'
// naming convention [entity][action][related entity][Update | Query][Input | Output]

export const USER_FOLLOW_USER = gql`
  mutation UserFollowUser($input: SubscribePublicUserInput!) {
    subscribePublicUser(input: $input) {
      message
      status
    }
  }
`

export const USER_UNFOLLOW_USER = gql`
  mutation UserUnfollowUser($input: SubscribePublicUserInput!) {
    unsubscribePublicUser(input: $input) {
      message
      status
    }
  }
`

export const USER_JOIN_GROUP = gql`
  mutation UserJoinUserGroup($input: SubscribeUserGroupInput!) {
    subscribeUserGroup(input: $input) {
      message
      status
    }
  }
`

// naming convention [entity][action][related entity][Update | Query][Input | Output]
export const USER_LEAVE_GROUP = gql`
  mutation UserLeaveUserGroup($input: SubscribeUserGroupInput!) {
    unsubscribeUserGroup(input: $input) {
      message
      status
    }
  }
`
